// extracted by mini-css-extract-plugin
export default {"CheckboxWrapper":"AssessmentCards_CheckboxWrapper__1gZms","ChoiceColumn":"AssessmentCards_ChoiceColumn__Qj2BY","CheckboxAssessment":"AssessmentCards_CheckboxAssessment__7b3jZ"};